export default __webpack_public_path__ + "3ae0ee9847715bf8a1ca976cdcff1fe9.ttf";